module.exports = __webpack_public_path__ + "static/llt-5d2d960a258ca45942ff12c471dce598.png";